import { get, post } from '../../../../../../infra/rest';
import requestConfig from '../../../../../../shared/config/request';
import { urlCreator } from '../../../../../../shared/utils/url-helpers';
import { PlanAddonTypes } from '../../../../../renew-plan/v1/typings';
import { AddonGetTrialApiResponse, AddonPostTrialApiResponse, AssignLicensesRequest } from '../typings';

export const getTrialDetails = async (addonId: PlanAddonTypes): Promise<AddonGetTrialApiResponse> => {
  const url = urlCreator({
    baseUrl: `${requestConfig.aiBotBaseUrl}/v1/addon/trial/:addonId`,
    params: { addonId },
  });
  return get<AddonGetTrialApiResponse>(url, {}, true, false, true);
};

export const startTrial = async (addonId: string): Promise<AddonPostTrialApiResponse> => {
  const url = urlCreator({
    baseUrl: `${requestConfig.aiBotBaseUrl}/v1/addon/trial`,
  });
  return post<AddonPostTrialApiResponse>(url, { body: JSON.stringify({ addonId }) }, true, false, true);
};

export const assignCallLicenses = async (request: AssignLicensesRequest): Promise<void> => {
  const url = urlCreator({
    baseUrl: `${requestConfig.aiBotBaseUrl}/v1/call/license`,
  });
  return post<void>(url, { body: JSON.stringify(request) }, true, false, true);
};
